import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const ToastContext = createContext();

const ToastProvider = ({ children, value }) => {
  const [toastProps, setToastProps] = useState(null);
  return (
    <ToastContext.Provider
      value={{
        toastProps,
        setToastProps,
        ...value,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    open: PropTypes.bool,
    message: PropTypes.string,
    variant: PropTypes.oneOf(['success', 'alert', 'error', 'info']),
    autoHideDuration: PropTypes.number,
  }),
};

ToastProvider.defaultProps = {
  value: null,
};

export { ToastContext as default, ToastProvider };
